import axios from 'axios';

const BASE_URL = 'https://api.easypoint.com.tr/mailapi';
const AUTH_HEADER = 'Basic YWRtaW46NDQ1NTY2TXVoYXNlYmU=';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    accept: '*/*',
    authorization: AUTH_HEADER,
    'content-type': 'application/json',
  },
});

export const getMailList = () => apiClient.get('/mail-list');

export const sendMail = (payload) => apiClient.post('/sendMail', payload);
